import http from '@/lib/Http'

const path = '/wechat'

const binding = (id, openId) => {
    return new Promise((resolve, reject) => {
        http.get(path + "/bind", {id, openId}).then(resp => {
            if (resp.status === 200) {
                resolve(resp)
            } else {
                reject(resp)
            }
        }).catch(reject)
    })
}

export default {
    binding
}
